import { ElementTag } from "@/core/graphql/graphql";
import { Column } from "@/shared/components/table/table.model";
import { extractProperty } from "@/utils/extract-property";

export const ELEMENT_COLUMNS: Column<ElementTag>[] =[
  { columnId: 'id', caption: 'ID', fieldSelector: (element) => extractProperty(element.tag?.id) },
  { columnId: 'name', caption: 'Name', fieldSelector: (element) => extractProperty(element.tag?.name) },
  {
    columnId: 'isSystemAssigned',
    caption: 'Automatically Assigned',
    fieldSelector: (element) => element.isSystemAssigned ? 'Yes' : 'No',
  },
];
